__turbopack_context__.v({
  "productAskAndAnswerHeader": "ProductAskAndAnswer-module-scss-module__qLJb2a__productAskAndAnswerHeader",
  "productAskAndAnswerSection": "ProductAskAndAnswer-module-scss-module__qLJb2a__productAskAndAnswerSection",
  "productAskAndAnswerSubtitle": "ProductAskAndAnswer-module-scss-module__qLJb2a__productAskAndAnswerSubtitle",
  "productAskAndAnswerTitle": "ProductAskAndAnswer-module-scss-module__qLJb2a__productAskAndAnswerTitle",
});
